import Component from 'gia/Component'
import _each from 'lodash.foreach'

import Observer from '../components/observer';


class Animation extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')

    this.element = element
    this.el = $(element)
    this.i = 0


    this.ref = {
      img: null,
      trigger: null,
      cover: null

    }

  }

  mount() {



    this.sections = new Observer({
        rootMargin: '-1%'
    })

 
  


       this.invanim = new Observer({
         rootMargin: '10% 0% 10% 0%'
       })
       this.invanim.add('.invanim')
    

    // ScrollTrigger.create({
    //   trigger: this.ref.cover,
    //   start: "top top",
    //   id: `id70`,
    //   onEnter: (self) => {
    //     $('body').addClass(`has-nav`)
    //   },
    //   onLeaveBack: (self) => {
    //     $('body').removeClass(`has-nav`)
    //   }
    // });


  }



  unmount() {


    this.observer.disconnect()
    this.sections.disconnect()
    this.locations.disconnect()
    this.menu.disconnect()
    this.tease.disconnect()
    this.invanim.disconnect()

   // ScrollTrigger.getById('id70').kill();

  }


}

module.exports = Animation